import Product from 'src/models/order/product/Product'
import LockerType from 'src/models/locker/LockerType'
import DurationPeriod from 'src/models/period/DurationPeriod'
import ReservationPlanningRequestJson from 'src/models/order/interfaces/ReservationPlanningRequestJson'
import { ReservationStatus } from 'src/models/reservation/enums/ReservationStatus'
import { DateTime } from 'luxon'
import { DerivedReservationStatus } from 'src/models/order/enums/OrderItemStatus'

export default class ReservationPlanningRequest extends Product {
  static readonly PRODUCT_TYPE = 'reservation'

  readonly lockerType: LockerType
  readonly durationPeriod: DurationPeriod
  readonly status: ReservationStatus
  readonly reservationToken: string | null

  constructor(
    lockerType: LockerType,
    durationPeriod: DurationPeriod,
    status: ReservationStatus,
    reservationToken: string | null,
  ) {
    super(ReservationPlanningRequest.PRODUCT_TYPE)
    this.lockerType = lockerType
    this.durationPeriod = durationPeriod
    this.status = status
    this.reservationToken = reservationToken
  }

  static is(p: Product): p is ReservationPlanningRequest {
    return p instanceof ReservationPlanningRequest
  }

  getStatus(
    timezone?: string,
  ): ReservationStatus | DerivedReservationStatus.STATUS_EXPIRED {
    const now = DateTime.now().setZone(timezone)
    return this.isExpired(now)
      ? DerivedReservationStatus.STATUS_EXPIRED
      : this.status
  }

  isExpired(now: DateTime) {
    return now > this.durationPeriod.endDate
  }

  static fromJson(data: ReservationPlanningRequestJson) {
    return new this(
      LockerType.fromJson(data.lockerType),
      DurationPeriod.fromJson(data.durationPeriod),
      data.status,
      data.reservationToken,
    )
  }

  toJson(): ReservationPlanningRequestJson {
    return {
      productType: this.productType,
      lockerType: this.lockerType.toJson(),
      durationPeriod: this.durationPeriod.toJson(),
      status: this.status,
      reservationToken: this.reservationToken,
    }
  }
}
